import {LitElement, svg, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';
import {
	selectSolarActivityLevel
} from '../../solarSelectors';

@customElement('svg-activity-level')
export class SvgActivityLevel extends connect(store)(LitElement) {

	static styles = css`
	  :host {
		display: flex;
		  height: 100%;
	  }

	  svg {
		height: 100%;
		width: auto;
		margin: auto;
	  }

	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.decisions = state.decisions.data;
		this.solar = state.solar.data;
		this.status = state.status;
		this.activityLevel = selectSolarActivityLevel(this.state);
	}

	render() {
		const s = this.state;
		const svgPath = this.status.host + this.status.baseUrl + 'visuals/activityLevel.svg';
		return svg`
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 460" text-rendering="geometricPrecision" shape-rendering="geometricPrecision" height="460" width="1000" style="white-space: pre;">
				<use href="${svgPath}#${this.activityLevel}"></use>
			</svg>
		`;
	}
}
